// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accordion {\n  transition-duration: 200ms;\n  transition-property: height;\n  transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n  overflow: hidden;\n  height: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
